/** Web stub: no native ad SDK on the showcase, so rewarded ads never run. */
export async function showRewardedAd(): Promise<{ earned: boolean }> {
  return { earned: false };
}
